import { isValidPhoneNumber } from 'react-phone-number-input';

import { type OnboardingExperience } from '@/utils/onboardingExperience';

import { type PersonalizationFormData } from '../personalizationTypes';

/**
 * Returns true when the user has opted in to the request-demo CTA (or the
 * webinar booked-out phone fallback) but hasn't supplied a valid phone +
 * reason. HubSpot's SDR form 400s without those fields (per f4c402759e), so the
 * parent's "submit" / "continue" button should be disabled while this returns
 * true.
 *
 * Used by:
 * - LearnBasics flow → clinic step continue gate
 * - v2 flow → completion step "Get Started" button
 *
 * @param webinarBookedOut When true, a `webinar` experience with no available
 *   sessions shows the same phone + reason fallback and is gated identically.
 */
export function isRequestDemoBlocked(
  experience: OnboardingExperience,
  formData: Pick<PersonalizationFormData, 'ctaOptIn' | 'demoReason' | 'phoneNumber'>,
  webinarBookedOut = false
): boolean {
  const showsPhoneFallback =
    experience.type === 'request-demo' ||
    (experience.type === 'webinar' && webinarBookedOut);

  return (
    showsPhoneFallback &&
    formData.ctaOptIn &&
    (!formData.demoReason.trim() || !isValidPhoneNumber(formData.phoneNumber))
  );
}
